
/*!
 * Jade - nodes - Node
 * Copyright(c) 2010 TJ Holowaychuk <tj@vision-media.ca>
 * MIT Licensed
 */

/**
 * Initialize a `Node`.
 *
 * @api public
 */

var Node = module.exports = function Node(){};

/**
 * Clone this node (return itself)
 *
 * @return {Node}
 * @api private
 */

Node.prototype.clone = function(){
  return this;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/~/jade/lib/nodes/node.js
 ** module id = 108
 ** module chunks = 1
 **/